import { CrystalMark } from '@/assets/icons';
import type { TelegramUser } from '@/types/user';
import styles from './ProfileHeader.module.scss';

export interface ProfileHeaderProps {
  user: TelegramUser | null;
  hasPremium: boolean;
}

function initialFor(user: TelegramUser | null): string {
  const source = user?.firstName ?? 'D';
  return source.trim().charAt(0).toUpperCase() || '?';
}

export function ProfileHeader({ user, hasPremium }: ProfileHeaderProps) {
  const displayName = user ? [user.firstName, user.lastName].filter(Boolean).join(' ') : 'Dariush';
  const username = user?.username ? `@${user.username}` : '@dariush';

  return (
    <div className={styles.head}>
      <div className={styles.avatar}>
        {user?.photoUrl ? (
          <img className={styles.avatarImg} src={user.photoUrl} alt="" />
        ) : (
          initialFor(user)
        )}
      </div>
      <div>
        <div className={styles.name}>{displayName}</div>
        <div className={styles.username}>{username}</div>
        {hasPremium && (
          <div className={styles.premiumPill}>
            <CrystalMark size={11} flat />
            Premium active
          </div>
        )}
      </div>
    </div>
  );
}
